<template>
  <InfoCard
    class="additional-info-container"
    icon="iconfont icona-ApplicationConfiguration"
    :title="$t(`${i18nPrefix}.title.additionalInfo`)"
    :infoList="infoList"
    :infoLines="infoLines"
  ></InfoCard>
</template>

<script>
import _ from 'lodash'
import InfoCard from '@/components/candidate/infoCard.vue'
import { getConstantI18nValue } from '@/i18n'
import { CERTIFICATION, LANGUAGE, LANGUAGE_LEVEL } from '@/constant/meta'

export default {
  components: {
    InfoCard
  },
  props: {
    languageList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    infoList () {
      return [{
        language: this.languageList
      }]
    },
    infoLines () {
      const i18nPrefix = this.i18nPrefix
      const lines = {
        language: {
          labelI18nKey: `${i18nPrefix}.label.language`,
          formatter: this.formatLanguage,
          multipleText: true
        }
      }
      return lines
    }
  },
  created () {

  },
  methods: {
    formatLanguage (languageList) {
      return _.chain(languageList).map(language => {
        if (!language.language) {
          return
        }
        const languageName = getConstantI18nValue(LANGUAGE, language.language, 'meta.LANGUAGE')
        const levelName = getConstantI18nValue(LANGUAGE_LEVEL, language.level, 'meta.LANGUAGE_LEVEL')
        const certificationName = getConstantI18nValue(CERTIFICATION, language.certification, 'meta.CERTIFICATION')
        const score = parseInt(language.score)
        const levelInfo = _.chain([levelName, certificationName, score]).filter().join(', ').value()
        return `${languageName} ${levelInfo && `(${levelInfo})`}`
      }).filter().join('\n').value()
    }
  }
}
</script>

<style lang="scss" scoped>
.additional-info-container {
  ::v-deep {
    .card-title-container {
      .title-icon {
        display: inline-block;
        width: 26px;
        line-height: 26px;
        border-radius: 50%;
        background: #9a999b;
        color: #ffffff;
        font-size: 16px;
        text-align: center;

        &::before {
          display: inline-block;
          margin-left: -2px;
        }
      }
    }

    .card-list {
      .info-card {
        .info-line {
          width: 100%;
        }
      }
    }
  }
}
</style>
